module.exports = __webpack_public_path__ + "img/1542601486.f10a8230.jpg";